import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FilterSummaryItem from '../../atoms/FilterSummaryItem'
import { Button, Box, Text, Flex, mediaQueries } from 'pcln-design-system'

const propTypes = {
  filters: PropTypes.array.isRequired, // one child per filterable item to control show-hides
  handleChange: PropTypes.func.isRequired,
  filterNamePrefix: PropTypes.string,
  className: PropTypes.string,
  filterSummaryTitle: PropTypes.string,
  scrollMode: PropTypes.bool,
  clearAllText: PropTypes.string,
  zindex: PropTypes.string,
}

const defaultProps = {
  scrollMode: false,
  clearAllText: 'Clear All',
}

const FilterSummaryCategoryWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  ${(props) =>
    props.scrollMode
      ? `
    max-width: 100%;
    overflow: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;

    ${mediaQueries.md} {
      max-width: none;
      flex-wrap: wrap;
    }
  `
      : ``}
`

const StyledFilterSummaryText = styled(Text)`
  width: 256px;

  @media screen and (min-width: 256px) {
    width: auto;
  }
`

const ClearAllLink = styled(Button)`
  flex-shrink: 0;
  &:hover {
    text-decoration: none;
  }
`

const Items = styled(Flex)`
  ${(props) => (props.zindex ? `z-index: ${props.zindex} ;` : ``)}
  ${(props) =>
    props.scrollMode
      ? `
    flex-wrap: nowrap;
    ${mediaQueries.md} {
      flex-wrap: wrap;
    }
  `
      : 'flex-wrap: wrap;'}
`

class FilterSummaryCategoryGroup extends React.Component {
  render() {
    const { filterSummaryTitle, handleChange, scrollMode, clearAllText, zindex } = this.props

    const items = this.props.filters.map((filter, index) => {
      return <FilterSummaryItem {...filter} key={`FilterSummaryItem_${index}`}></FilterSummaryItem>
    })

    const ClearAllLinkButton = (
      <ClearAllLink variation='link' scrollMode={scrollMode} onClick={handleChange} data-testid='CLEAR_ALL'>
        <Text
          bold
          fontWeight='bold'
          pl={[scrollMode ? 0 : 2, null, 2]}
          pr={[scrollMode ? 3 : 2, null, 2]}
          pb={2}
          color='primary'
          fontSize={[scrollMode ? 1 : 2, null, 2]}
        >
          {clearAllText}
        </Text>
      </ClearAllLink>
    )

    return (
      <FilterSummaryCategoryWrapper scrollMode={scrollMode}>
        {filterSummaryTitle && (
          <StyledFilterSummaryText
            bold
            data-testid='SUMMARY_TITLE'
            fontWeight='bold'
            pr={2}
            pb={2}
            color='text'
            fontSize={2}
          >
            {filterSummaryTitle}
          </StyledFilterSummaryText>
        )}
        {scrollMode && ClearAllLinkButton}
        <Items
          scrollMode={scrollMode}
          align='center'
          alignItems='center'
          py={[scrollMode ? 2 : 0, null, 0]}
          zindex={zindex}
          data-testid='FILTER_SUMMARY_ITEMS'
        >
          {scrollMode ? (
            <React.Fragment> {items} </React.Fragment>
          ) : (
            <React.Fragment>
              {items} {ClearAllLinkButton}
            </React.Fragment>
          )}
        </Items>
      </FilterSummaryCategoryWrapper>
    )
  }
}

FilterSummaryCategoryGroup.propTypes = propTypes
FilterSummaryCategoryGroup.defaultProps = defaultProps

export default FilterSummaryCategoryGroup
